import Vue from 'vue';
import Component from 'vue-class-component';
import { TransferOutStateEnum, TransferInStateEnum } from '@/types/crm-enums';

@Component({
})

export default class Details extends Vue {
  public data1: Array<{ label: string, value: string | number }> = [];
  public goback() {
    this.$router.go(-1);
  }
  public activated() {
    this.data1 = [];
    if(process.env.NODE_ENV === 'development')
      console.log(this.$route.params);
    if (this.$route.params.PayChannel) {
      const data = this.$route.params as any as TransferInModel;
      this.data1.push({ label: '时间', value: data.Indate });
      this.data1.push({ label: '总金额', value: data.TotalMoney });
      this.data1.push({ label: '服务费', value: data.ServiceCharge });
      this.data1.push({ label: '到账金额', value: this.inRealMoney(data) });
      this.data1.push({ label: '支付方式', value: data.PayType });
      this.data1.push({ label: '支付渠道', value: data.PayChannel });
      this.data1.push({ label: '流水号', value: data.PayNo });
      this.data1.push({ label: '状态', value: data.StateStr });
    } else {
      const data = this.$route.params as any as TransferOutModel;

      this.data1.push({ label: '时间', value: data.Indate });
      this.data1.push({ label: '姓名', value: data.Name });
      this.data1.push({ label: '银行', value: data.Bank });
      this.data1.push({ label: '支行', value: data.BankBranch });
      this.data1.push({ label: '银行卡号', value: data.BankNo });
      this.data1.push({ label: '流水号', value: data.PayNo });
      this.data1.push({ label: '提款金额', value: data.TotalMoney });
      this.data1.push({ label: '手续费', value: data.ServiceCharge });
      this.data1.push({ label: '实际到账', value: this.outRealMoney(data) });
      this.data1.push({ label: '状态', value: data.StateStr });
    }
  }
  public outRealMoney(item: TransferOutModel) {
    switch (item.State) {
      case TransferOutStateEnum.Accept:
        return item.Money;
      default:
        return '0';
    }
  }
  public inRealMoney(item: TransferInModel) {
    switch (item.State) {
      case TransferInStateEnum.Accept:
      case TransferInStateEnum.PaySuc:
        return item.Money;
      default:
        return '0';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/DrawMoneyRecord/Details/Details.ts